import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { editCommunityFeedItemCache } from 'src/Services/API/cache';
import { CommunityFeedItemDto } from 'src/Services/API/generated';

import useFetchUser from '../Queries/useFetchUser';

export const useDeleteCommunityFeedItemLike = (
  options?: UseMutationOptions<void, unknown, string>
) => {
  const queryClient = useQueryClient();
  const myself = useFetchUser();

  return useMutation<void, unknown, string>(
    'delete-community-feed-item-like',
    async (data: string) => {
      const response = await communityFeedApi.communityFeedControllerRemoveLike(data);

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        editCommunityFeedItemCache(queryClient, feedItem => {
          if (feedItem.id !== variables) return feedItem;

          return {
            ...feedItem,
            likes: {
              ...feedItem.likes,
              count: Math.max(feedItem.likes.count - 1, 0),
              didILike: false,
              firstFive: feedItem.likes.firstFive.filter(like => like.from.id !== myself.data?.id),
            },
          };
        });

        // optimistic rendering for feed item detail
        const detailQueryKey = ['fetch-community-feed-item', variables];
        const currentItem = queryClient.getQueryData<CommunityFeedItemDto>(detailQueryKey);

        if (currentItem) {
          queryClient.setQueryData<CommunityFeedItemDto>(detailQueryKey, {
            ...currentItem,
            likes: {
              ...currentItem.likes,
              count: currentItem.likes.count - 1,
              didILike: false,
              firstFive: currentItem.likes.firstFive.filter(
                like => like.from.id !== myself.data?.id
              ),
            },
          });
        }

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
